/*
 * @Author: redu842 2150673512@qq.com
 * @Date: 2023-10-27 09:07:48
 * @LastEditors: redu842 2150673512@qq.com
 * @LastEditTime: 2023-12-09 14:43:29
 * @FilePath: \minipro-manger\src\router\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from "../views/Login"
import Home from "../views/Home"
import WeatherAlert from "../views/WeatherAlert"
import RuralTou from "../views/RuralTou"
import IntelligentBase from "../views/IntelligentBase"
import UserFeedback from "../views/UserFeedback"
import Send from "../views/Send"
import menuSet from "../views/menuSet"
import RiskSurvey from "../views/RiskSurvey"
import AreaList from "../views/AreaList"
import PlanList from "../views/PlanList"
import Guidance from "../views/Guidance"
import UserData from "../views/UserData"

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'login',
    component: Login
  },
  {
    path: '/home',
    name: 'Home',
    component: Home,

    children: [{
      path: '/weatherAlert',
      component: WeatherAlert,
    }
      ,
    {
      path: '/RuralTou',
      component: RuralTou,
    },
    {
      path: '/IntelligentBase',
      component: IntelligentBase,
    },
    {
      path: '/UserFeedback',
      component: UserFeedback,
    },
    {
      path: '/Send',
      component: Send,
    },
    {
      path: '/menuSet',
      component: menuSet,
    },
    {
      path: '/RiskSurvey',
      component: RiskSurvey,
    },
    {
      path: '/AreaList',
      component: AreaList,
    },
    {
      path: '/PlanList',
      component: PlanList,
    },
    {
      path: '/Guidance',
      component: Guidance,
    },
    {
      path: '/UserData',
      component: UserData,
    }
    ]
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router
